// extracted by mini-css-extract-plugin
module.exports = {"description":"Accordion-module-description"};